<template>
    <v-dialog v-model="show" no-click-animation persistent width="800">
        <div class="AgentInterrupt">
            <div class="dialog-header">
                <div>{{ $f.tc('interrupt') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <div class="dialog-content fci-scrollbar">
                <div class="centerY">
                    <div class="centerXY">
                        <v-switch v-model="mode" :readonly="!isEdit" color="#0052cc"
                                  @change="switchMode"></v-switch>
                        <div class="label mb-0 mt-0 mr-12">{{ $f.tc('useInterrupt') }}</div>
                    </div>
                </div>
                <div v-if="mode">
                    <div style="margin-top: 5px; position: relative"
                         v-for="(item, index) in model.conditions" :key="index">
                        <div class="interrupt-config">
                            <div class="interrupt-header mb-3">
                                <div v-if="isEdit" style="position: absolute; top:0; right:0">
                                    <v-btn small icon @click="deleteInterruptCondition(index) ">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                            <div class="centerY pb-2">
                                <div class="label" style="margin-bottom: 0 !important;">{{
                                        $f.tc('interruptMethod')
                                    }}
                                </div>
                                <v-text-field
                                    outlined
                                    hide-details
                                    type="number"
                                    v-model="item.interrupt_method"
                                    :min="0"
                                    :max="4"
                                    @focusout="validateInterruptMethod(index)"
                                    class="input-custom input-number ml-2"
                                    style="max-width: 60px; margin-top: 0 !important; padding-top: 0 !important;"
                                    :readonly="!isEdit"
                                ></v-text-field>
                            </div>
                            <div class="label" style="margin-bottom: 0 !important;">{{
                                    $f.tc('interruptCondition')
                                }}
                            </div>
                            <v-text-field
                                outlined
                                type="string"
                                v-model="item.current_agent_action"
                                placeholder="Current action"
                                class="input-custom"
                                :readonly="!isEdit"
                            ></v-text-field>
                            <div v-show="!(item.interrupt_method === '4')">
                                <div class="label" style="margin-bottom: 0 !important;">{{
                                        $f.tc('interruptPhrase')
                                    }}
                                </div>
                                <div class="centerY">
                                    <v-text-field
                                        outlined
                                        hide-details
                                        ref="newInterruptPhrase"
                                        type="string"
                                        @keypress.enter="addNewInterruptPhrase(index)"
                                        v-model="item.new_interrupt_phrase"
                                        maxlength="50"
                                        placeholder="Interrupt phrase"
                                        class="input-custom"
                                        :readonly="!isEdit"
                                    ></v-text-field>
                                </div>
                                <div class="monitoring-bar centerY scrollbar-horizontal-thin">
                                    <div class="centerY mr-6" style="gap: 6px;flex-wrap: wrap"
                                         v-if="item['interrupt_phrases'] && item['interrupt_phrases'].length > 0">
                                        <div class="tag-item centerXY"
                                             v-for="(phrase, phraseIndex) in item['interrupt_phrases']"
                                             :key="phrase">
                                            {{ phrase }}
                                            <img v-if="phrase && isEdit" src="/img/debug/close-circle.svg"
                                                 alt="icon-close"
                                                 @click="deleteInterruptPhrase(index, phraseIndex)">
                                        </div>
                                    </div>
                                </div>
                                <div class="label" style="margin-bottom: 0 !important;">{{
                                        $f.tc('interruptRegular')
                                    }}
                                </div>
                                <v-select
                                    outlined
                                    type="string"
                                    :items="interruptRegular"
                                    v-model="item.interrupt_regular"
                                    placeholder="Interrupt regular"
                                    class="input-custom"
                                    :readonly="!isEdit"
                                ></v-select>
                            </div>
                        </div>

                    </div>
                    <div v-if="isEdit" class="centerY justify-start mt-6">
                        <div class="btn-outline" @click="addInterruptCondition">
                            <img src="/img/add-blue.svg" alt="icon-add-interrupt-config"
                                 style="margin-right: 6px; transform: scale(1.1) ">
                            {{ $f.tc('addNew') }}
                        </div>
                    </div>
                </div>
            </div>
            <!--Footer dialog-->
            <div class="dialog-footer" v-if="isEdit">
                <div class="btn-custom mr-6"
                     @click="saveList">{{ $f.tc('save') }}
                </div>
                <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import {mapState} from "vuex";
import AgentService from "@/services/agent.service";
import DialogPromiseFormMixin from "@/modules/fptai/mixins/DialogPromiseFormMixin.vue";

const interruptModel = {
    "current_agent_action": "",
    "interrupt_phrases": [],
    "interrupt_regular": "keyword",
    "new_interrupt_phrase": "",
    "interrupt_method": "0"
}

export default {
    name: 'AgentInterrupt',
    mixins: [DialogPromiseFormMixin],
    computed: {
        ...mapState({
            interrupt: state => state.agent.interrupt
        }),
        isEdit() {
            return AgentService.isEditable()
        },
    },
    data() {
        return {
            mode: false,
            model: {
                mode: 'no',
                conditions: []
            },
            interruptRegular: [
                'keyword'
            ]
        }
    },
    methods: {
        switchMode() {
            this.model.mode = this.mode ? 'interrupt' : 'no'
        },
        addInterruptCondition() {
            this.model.conditions.push(this.$utils.cloneObject(interruptModel))
        },
        addNewInterruptPhrase(index) {
            let newPhrase = this.model.conditions[index].new_interrupt_phrase.trim()
            // validate duplicate
            if (this.model.conditions[index].interrupt_phrases.includes(newPhrase)) {
                this.$appService.toastError(this.$f.tc('interruptPhraseDuplicate'))
                this.model.conditions[index].new_interrupt_phrase = ""
                return
            }
            if (!newPhrase || newPhrase === '') {
                this.$appService.toastError(this.$f.tc('interruptPhraseBlank'))
                this.model.conditions[index].new_interrupt_phrase = ""
                return
            }
            if (this.model.conditions[index].interrupt_phrases.length === 15) {
                this.$appService.toastError(this.$f.tc('interruptPhrasesLimit'))
                this.model.conditions[index].new_interrupt_phrase = ""
                return
            }
            this.model.conditions[index].interrupt_phrases.push(newPhrase)
            this.model.conditions[index].new_interrupt_phrase = ""
        },
        deleteInterruptCondition(index) {
            this.model.conditions.splice(index, 1)
        },
        deleteInterruptPhrase(index, phraseIndex) {
            let phraseList = this.model.conditions[index].interrupt_phrases
            if (phraseList.length === 0) {
                this.$appService.toastError(this.$f.tc('interruptPhrasesEmpty', [index]))
                return
            }
            phraseList.splice(phraseIndex, 1)
        },
        saveList() {
            if (this.checkInterruptCondition()) {
                let data = Object.keys(this.interrupt.value).length === 0 ? {
                    mode: 'no',
                    conditions: []
                } : this.$utils.cloneObject(this.interrupt.value)
                data.mode = this.mode ? 'interrupt' : 'no'
                if (this.mode) {
                    let temp = this.$utils.cloneObject(this.model.conditions)
                    for (let condition of temp) {
                        condition.interrupt_phrases = condition.interrupt_phrases.join(';')
                        delete condition.new_interrupt_phrase
                    }
                    data.conditions = temp
                }
                this.$store.dispatch(this.$actionTypes.agent.UPDATE_INTERRUPT, {
                    id: this.interrupt.id,
                    value: data
                }).then(() => {
                    this.close()
                })
            }
        },
        open() {
            this.show = true
            this.loadInterrupt()
        },
        loadInterrupt() {
            if (Object.keys(this.interrupt.value).length === 0) {
                return
            }
            this.model = {
                mode: 'no',
                conditions: []
            }
            if (this.interrupt.value.mode === 'interrupt') {
                this.mode = true
                this.model.mode = 'interrupt'
            } else {
                this.mode = false
                this.model.mode = 'no'
            }
            for (let item of this.interrupt.value.conditions) {
                let temp = this.$utils.cloneObject(interruptModel)
                temp.current_agent_action = item.current_agent_action
                temp.interrupt_phrases = item.interrupt_phrases ? item.interrupt_phrases.split(';') : []
                temp.interrupt_regular = item.interrupt_regular
                temp.interrupt_method = item.interrupt_method ? item.interrupt_method : "0"
                this.model.conditions.push(temp)
            }
        },
        checkInterruptCondition() {
            let valid = true
            for (let [index, item] of this.model.conditions.entries()) {
                if (item.interrupt_phrases.length === 0 && item.interrupt_method !== "4") {
                    this.$appService.toastError(this.$f.tc('interruptPhrasesEmpty', [index + 1]))
                    valid = false
                }
            }
            let keySet = new Set()
            for (let condition of this.model.conditions) {
                let playingCondition = condition.current_agent_action
                if (!keySet.has(playingCondition)) {
                    keySet.add(playingCondition);
                } else {
                    this.$appService.toastError(this.$f.tc('interruptConditionDuplicate', [playingCondition]))
                    valid = false;
                }
            }

            return valid
        },
        validateInterruptMethod(index) {
            if (parseInt(this.model.conditions[index].interrupt_method) <= -1) {
                this.model.conditions[index].interrupt_method = 0
            }

            if (!this.model.conditions[index].interrupt_method) {
                this.model.conditions[index].interrupt_method = 0
            }

            if (this.model.conditions[index].interrupt_method > 4) {
                this.model.conditions[index].interrupt_method = 0
            }

            if (this.model.conditions[index].interrupt_method < 0) {
                this.model.conditions[index].interrupt_method = 0
            }
        }
    }
}

</script>

<style scoped lang="scss">
.AgentInterrupt {
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .dialog-content {
        padding: 12px;
        max-height: calc(85vh - 100px);
        overflow-y: auto;
    }
}

.interrupt-config {
    border-radius: 5px;
    border: 1px solid #D9D9D9;
    padding: 10px 12px;
}

.interrupt-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.monitoring-bar {
    padding: 8px 0;
    background: #FFFFFF;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;

    .tag-item {
        padding: 0 6px 0 8px;
        height: 25px;
        line-height: 25px;
        background: #EAEEFF;
        color: #0052CC;
        border-radius: 4px;
        font-size: 13px;
        font-family: "open sans", serif;

        img {
            cursor: pointer;
            width: 18px;
            margin-left: 3px;
        }
    }
}
</style>
